import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import qs from 'qs'

import Meta from "../components/layout/Meta";
import { Path, PathGenerator } from "../constants/path";
import { ExternalPath } from "../constants/path";
import { Link, Button } from "../components/util/Clickable";
import MapBase from "../components/view/Map";
import FacilityCard from "../components/view/FacilityCard";
import Search from "../components/view/Search";

import { getFacilities } from "../actions/facility";

class MapScreen extends Component {

  state = {
    facilities: null,
    query: null,
    loading:false,
    meta: {
      current_page: 0,
      last_page: 0,
    },
  }

  componentWillMount = () => {
    const query = qs.parse(this.props.location.search.replace("?", ""));
    this.setState({
      query: query
    }, () => {
      this.loadMore(true);
    });
  }

  componentWillReceiveProps = (nextProps) => {
    if( this.props.location.search != nextProps.location.search ){
      const query = qs.parse(nextProps.location.search.replace("?", ""));
      this.setState({
        query: query
      }, () => {
        this.loadMore(true);
      });
    }
  }

  loadMore = (refresh=false) => {
    this.setState({
      loading: true
    });
    var params = this.state.query;
    params.pagesize = 100;
    if(!refresh){
      params.page = this.state.meta.current_page + 1;
    }
    this.props.actions.getFacilities(params).then(({value}) => {
      if( value.status >= 300 ){
        return;
      }
      this.setState({
        facilities: (refresh || this.state.facilities == null ) ? value.data: this.state.facilities.concat(value.data),
        meta: value.response.data.meta,
        loading: false
      });
    });  
  }

  renderBread = () => {
    var links = [];
    if(this.state.query.region_id){
      const region = this.props.constant.areas.find( (area, index) => {
        return area.id == this.state.query.region_id;
      });
      if(region){
        var query = {
          region_id: region.id
        }
        links.push( {
          label: region.label, url: Path.facilities.url + "?" + qs.stringify(query)
        });

        if(this.state.query.prefecture_id){
          const prefecture = region.prefectures.find( (area, index) => {
            return area.id == this.state.query.prefecture_id;
          });
          if(prefecture){
            var query = {
              region_id: region.id,
              prefecture_id: prefecture.id
            }
            links.push( {
              label: prefecture.label, url: Path.facilities.url + "?" + qs.stringify(query)
            });
            if(this.state.query.large_area_id){
              const large_area = prefecture.large_areas.find( (area, index) => {
                return area.id == this.state.query.large_area_id;
              });
              if(large_area){
                var query = {
                  region_id: region.id,
                  prefecture_id: prefecture.id,
                  large_area_id: large_area.id
                }
                links.push( {
                  label: large_area.label, url: Path.facilities.url + "?" + qs.stringify(query)
                });
              }
            }
          }
        }
      }
      
    }

    return (
      <ul className="uk-breadcrumb">
        <li><a href="http://spa-misasa.jp/">トップページ</a></li>
        <li><Link to={Path.facilities.url}>施設一覧</Link></li>
        {
          links.map( (link, index) => {
            return (
              <li key={index}>
                <Link to={link.url}>{link.label}</Link>
              </li>
            );
          })
        }
      </ul>
    );
  }

  renderMap = () => {
    if( !this.state.facilities ){
      return (
        <div className="uk-width-1-1 uk-height-large uk-position-relative">
          <div className="uk-position-center">
            <span data-uk-spinner="ratio: 3"></span>
          </div>
        </div>
      );  
    }

    if( this.state.facilities.length == 0 ){
      return (
        <div className="uk-width-1-1 uk-height-medium uk-position-relative">
          <div className="uk-position-center">
            <h4>検索条件に該当する施設がありませんでした。</h4>
          </div>
        </div>
      );
    }

    return (
      <MapBase isMarkerShown={true} facilities={this.state.facilities} />
    );
  }

  render = () => {
    return (
      <div>
        <Meta />
        <div className="uk-section">
          <div className="uk-container uk-container-small">
            <div data-uk-grid className="uk-grid-large">

              <div className="uk-width-expand">
                {
                  this.state.query && this.props.constant.areas && this.renderBread()
                }
                <hr/>
                <div className="uk-margin-medium">
                  { this.renderMap() }
                </div>
                {
                  this.state.facilities && (
                    <div className="uk-margin-medium">
                      <h2>
                        検索結果
                      </h2>
                      {
                        this.state.facilities.map( (facility, index) => {
                          return (
                            <div key={index} className="uk-margin-small">
                              <FacilityCard facility={facility} noLoad={true} />
                            </div>
                          );
                        })
                      }
                      {
                        (this.state.facilities != null && (this.state.meta.last_page > this.state.meta.current_page) ) && (
                          <div className="uk-margin uk-text-center">
                            <Button className="uk-button uk-button-secondary uk-button-large uk-width-large@s" loading={this.state.loading ? 1: 0} onClick={() => this.loadMore(false)}>
                              もっと見る
                            </Button>
                          </div>
                        )
                      }
                    </div>
                  )
                }
              </div>

              <div className="uk-width-large@s uk-width-1-1 uk-flex-first@s">
                <Search />
              </div>
              
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    constant: state.constant
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    getFacilities: (data) => dispatch(getFacilities(data)),
  }, dispatch)
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MapScreen))
